import React, { useState } from "react";
import { Form, Dropdown } from "react-bootstrap";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import VideocamOutlinedIcon from "@mui/icons-material/VideocamOutlined";
import ImageOutlinedIcon from "@mui/icons-material/ImageOutlined";
import LinkOutlinedIcon from "@mui/icons-material/LinkOutlined";

import {
  FiSearch,
  FiFilter,
  FiSettings,
  FiRefreshCw,
  FiMoreVertical,
  FiStar
} from "react-icons/fi";

const EmailInbox = ({ openEmail }) => {

const emails = [

{
id:1,
name:"Justin Lapointe",
subject:"Client Dashboard",
message:"It seems that recipients are receiving...",
time:"3:13 PM",
avatar:"CD",
label:"Projects",
labelColor:"#e7f1ff",
attachments:[
{type:"video",count:1},
{type:"link",count:1}
]
},

{
id:2,
name:"Rufana",
subject:"UI project",
message:"Regardless, you can usually expect an increase",
avatarImg:"/assets/img/profiles/avatar-01.jpg",
time:"3:13 PM",
label:"Applications",
labelColor:"#f3e8ff",
attachments:[
{type:"image",count:1}
]
},

{
id:3,
name:"Cameron Drake",
subject:"You're missing",
message:"Here are a few catchy email subject line examples",
avatarImg:"/assets/img/profiles/avatar-03.jpg",
time:"3:13 PM",
label:"External",
labelColor:"#ffe7e7",
attachments:[
{type:"video",count:1}
]
},

{
id:4,
name:"Sean Hill",
subject:"How Have You Progressed",
message:"You can write effective retargeting subject",
avatarImg:"/assets/img/profiles/avatar-04.jpg",
time:"3:13 PM",
label:"Team Events",
labelColor:"#e7fff0",
attachments:[
{type:"image",count:1}
]
},

{
id:5,
name:"Kevin Alley",
subject:"Flash. Sale. Alert.",
message:"You can also use casual language",
avatarImg:"/assets/img/profiles/avatar-05.jpg",
time:"3:13 PM",
label:"External",
labelColor:"#ffe7e7",
attachments:[
{type:"link",count:1}
]
},

{
id:6,
name:"Linda Zimmer",
subject:"Products the celebs are",
message:"It seems that recipients are receiving...",
avatarImg:"/assets/img/profiles/avatar-06.jpg",
time:"3:13 PM",
label:"Work",
labelColor:"#fff4e5",
attachments:[
{type:"link",count:1}
]
},

{
id:7,
name:"Emily Reachel",
subject:"No Subject",
message:"Announcing Fake Name Generator Premium",
avatar:"ER",
time:"3:13 PM",
label:"Projects",
labelColor:"#e7f1ff",
attachments:[
{type:"image",count:1}
]
}

];

const getIcon=(type)=>{

switch(type){

case "video":
return <VideocamOutlinedIcon style={{fontSize:16}}/>

case "image":
return <ImageOutlinedIcon style={{fontSize:16}}/>

case "link":
return <LinkOutlinedIcon style={{fontSize:16}}/>

default:
return null
}

}

const [search,setSearch] = useState("");

const filtered = emails.filter((mail)=>
mail.name.toLowerCase().includes(search.toLowerCase()) ||
mail.subject.toLowerCase().includes(search.toLowerCase())
);

return(

<div className="bg-white flex-fill border-end border-bottom inbox-container">

{/* HEADER */}

<div className="p-3 border-bottom d-flex justify-content-between align-items-center">

<div>
<h5 className="mb-1">Inbox</h5>

<div className="d-flex align-items-center">
<span>2345 Emails</span>
<span className="mx-2 text-primary">•</span>
<span>56 Unread</span>
</div>

</div>

<div className="d-flex align-items-center">

<div style={{position:"relative"}} className="me-3">

<FiSearch
style={{
position:"absolute",
left:"10px",
top:"10px",
color:"#777"
}}
/>

<Form.Control
placeholder="Search Email"
style={{paddingLeft:"35px",width:"200px"}}
onChange={(e)=>setSearch(e.target.value)}
/>

</div>

<FiFilter className="mx-2"/>
<FiSettings className="mx-2"/>
<FiRefreshCw className="mx-2"/>

</div>

</div>

{/* EMAIL LIST */}

<div className="email-scroll-area">

{filtered.map((mail)=>(

<div key={mail.id} className="border-bottom p-3" style={{cursor:"pointer"}}>

<div className="d-flex justify-content-between">

<div className="d-flex">

<input
type="checkbox"
className="me-3 mb-3"
style={{
transform:"scale(1.5)",
accentColor:"#f26522",
cursor:"pointer"
}}
/>

{mail.avatar ? (

<div
className="mt-2"
style={{
width:"40px",
height:"40px",
background:"#8e44ad",
color:"#fff",
borderRadius:"50%",
display:"flex",
alignItems:"center",
justifyContent:"center",
marginRight:"10px"
}}
>

{mail.avatar}

</div>

):( 

<img
className="mt-2"
src={mail.avatarImg}
alt=""
style={{
width:"43px",
height:"43px",
borderRadius:"50%",
marginRight:"10px"
}}
/>

)}

<div onClick={()=>openEmail(mail)}>

<h6 className="mb-1">{mail.name}</h6>

<div className="fw-semibold">{mail.subject}</div>

<p style={{fontSize:"14px",color:"#777"}}>
{mail.message}
</p>

</div>

</div>

{/* RIGHT */}

<div className="text-end d-flex align-item-center">

<Dropdown align="end">

<Dropdown.Toggle
className="mt-1 me-2"
variant="light"
size="sm"
style={{border:"none"}}
>

<MoreHorizIcon/>

</Dropdown.Toggle>

<Dropdown.Menu>

<Dropdown.Item>Open Email</Dropdown.Item>
<Dropdown.Item>Reply</Dropdown.Item>
<Dropdown.Item>Reply All</Dropdown.Item>
<Dropdown.Item>Forward</Dropdown.Item>
<Dropdown.Item>Forward As Attachment</Dropdown.Item>
<Dropdown.Item>Mark As Unread</Dropdown.Item>
<Dropdown.Item>Move to Junk</Dropdown.Item>
<Dropdown.Item>Mute</Dropdown.Item>
<Dropdown.Item>Delete</Dropdown.Item>
<Dropdown.Item>Archive</Dropdown.Item>
<Dropdown.Item>Move To</Dropdown.Item>

</Dropdown.Menu>

</Dropdown>

<div className="mt-2">
<span className="me-2 text-success">•</span>
{mail.time}
</div>

</div>

</div>

{/* FOOTER */}

<div className="d-flex justify-content-between mt-2">

<div className="d-flex gap-2">

{mail.attachments?.map((att,i)=>(
<span
key={i}
className="btn btn-sm bg-light d-flex align-items-center"
style={{gap:"5px"}}
>
{getIcon(att.type)}
{att.count}
</span>
))}

</div>

<div>

<div
style={{
display:"flex",
alignItems:"center",
gap:"6px"
}}
>

<span style={{color:"#f4b400",fontSize:"14px"}}>★</span>

<span
style={{
background:mail.labelColor || "#E9D5FF",
color:"#7C3AED",
padding:"4px 10px",
borderRadius:"8px",
fontSize:"12px",
fontWeight:"500"
}}
>

{mail.label}

</span>

<span
style={{
background:"#1F2937",
color:"#fff",
padding:"2px 6px",
borderRadius:"999px",
fontSize:"11px",
fontWeight:"500"
}}
>

+1

</span>

</div>

</div>

</div>

</div>

))}

</div>

<style>{`

.inbox-container{
height:100vh;
display:flex;
flex-direction:column;
}

.email-scroll-area{
flex:1;
overflow-y:auto;
}

.email-scroll-area::-webkit-scrollbar{
width:6px;
}

.email-scroll-area::-webkit-scrollbar-thumb{
background:#ccc;
border-radius:10px;
}

.dropdown-toggle::after {
display:none !important;
}

.form-check-input:checked {
background-color:#f26522;
border-color:#f26522;
}

.dropdown-item:hover {
background-color:#f26522;
color:#fff;
}

`}</style>

</div>

);

};

export default EmailInbox;